import { motion } from "framer-motion";
import { useContent } from "@/content/ContentContext";
import { useLang } from "@/i18n/LanguageContext";

const ease = [0.22, 1, 0.36, 1];

const initialsOf = (name) =>
  name.split(" ").map((w) => w[0]).join("").slice(0, 2).toUpperCase();

export default function Testimonials() {
  const content = useContent();
  const { t } = useLang();
  const stories = content.stories;
  return (
    <section
      id="stories"
      data-testid="stories-section"
      className="border-t border-line bg-moss/40"
    >
      <div className="mx-auto max-w-[1440px] px-6 py-28 lg:px-12 lg:py-40">
        <motion.p
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease }}
          className="text-xs uppercase tracking-[0.3em] text-harvest"
        >
          {t("storiesOverline")}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1, ease }}
          data-testid="stories-heading"
          className="mt-6 font-display text-4xl font-medium leading-[1.05] tracking-tight text-cream sm:text-5xl lg:text-6xl"
        >
          {t("storiesHeadA")} <span className="italic text-harvest">{t("storiesHeadAccent")}</span>
        </motion.h2>

        <div className="mt-16 grid gap-6 md:grid-cols-3">
          {stories.map((s, i) => (
            <motion.figure
              key={s.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.1, ease }}
              data-testid={`story-card-${i}`}
              className="flex flex-col border border-line bg-moss p-8 transition-transform duration-500 hover:-translate-y-1"
            >
              <span
                aria-hidden="true"
                className="font-display text-6xl font-light italic leading-none text-harvest/40"
              >
                &#8220;
              </span>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-cream/85 sm:text-base">
                {s.quote}
              </blockquote>
              <figcaption className="mt-8 flex items-center gap-4 border-t border-line pt-6">
                <span className="flex h-12 w-12 items-center justify-center border border-harvest/40 font-display text-sm italic text-harvest">
                  {initialsOf(s.name)}
                </span>
                <div>
                  <p className="text-sm font-medium text-cream">{s.name}</p>
                  <p className="mt-1 text-xs uppercase tracking-[0.15em] text-sage">
                    {s.place} — {s.crop}
                  </p>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
